import { Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { DialogActionsComponent } from '@proman/common-components/standalone/dialog-actions.component';
import { DialogTitleComponent } from '@proman/common-components/standalone/dialog-title.component';
import { Employee } from '@proman/interfaces/entity-interfaces';
import { CurrUser } from '@proman/interfaces/object-interfaces';
import { PromanListManagerModule } from '@proman/list-manager/list-manager.module';
import { filter, take } from '@proman/rxjs-common';
import { getCurrUser } from '@proman/store/curr-user';

@Component({
    selector: 'pro-smartsign-signing-dialog',
    template: `
        <pro-dialog-title title="select_signers"></pro-dialog-title>
        <section mat-dialog-content>
            <pro-list-manager
                [items]="signing.signers"
                [config]="{
                    label: 'signers',
                    preventHandling: true,
                    mainEntity: signing,
                    searchEntity: 'employee'
                }"
                (onAdd)="addSigner($event)"
                (onRemove)="removeSigner($event)"></pro-list-manager>
        </section>
        <pro-dialog-actions variant="confirm" (callback)="confirm()"></pro-dialog-actions>
    `,
    imports: [DialogTitleComponent, DialogActionsComponent, MatDialogModule, PromanListManagerModule],
})
export class SmartsignSigningDialogComponent implements OnInit {
    private dialogRef = inject<MatDialogRef<SmartsignSigningDialogComponent>>(MatDialogRef);

    store = inject(Store);

    currUser: CurrUser;
    signing = { signers: [] };

    ngOnInit() {
        this.store
            .select(getCurrUser)
            .pipe(
                filter((value) => !!value),
                take(1)
            )
            .subscribe((value) => {
                this.currUser = value;
                this.signing.signers.push(value.person);
            });
    }

    addSigner(value: Employee) {
        this.signing.signers.push(value);
        console.log(value);
    }

    removeSigner(value: unknown) {
        console.log(value);
    }

    confirm() {
        this.dialogRef.close({ signers: this.signing.signers.map((datum) => datum.id) });
    }
}
